import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { deleteConversation, listConversations, renameConversation } from '../api/chat-api';

export const CONVERSATIONS_QUERY_KEY = ['chat', 'conversations'] as const;

export function useConversationList() {
  return useQuery({
    queryKey: CONVERSATIONS_QUERY_KEY,
    queryFn: () => listConversations({ limit: 50 }),
    staleTime: 30_000,
  });
}

// Deletes a conversation, then refreshes the sidebar list so the row drops out.
export function useDeleteConversation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteConversation(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: CONVERSATIONS_QUERY_KEY });
    },
  });
}

// Renames a conversation, then refreshes the sidebar list with the new title.
export function useRenameConversation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, title }: { id: string; title: string }) => renameConversation(id, title),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: CONVERSATIONS_QUERY_KEY });
    },
  });
}
